import React from 'react';
import styled from 'styled-components';

import { formatPricePerMonth } from '@front/common/src/utils/formatting';
import { getCurrentCountry } from '@front/common/src/utils/country';

import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '@front/customer/src/constants/country-config';

import { translate } from '@front/i18n';

import { minWidth } from '@front/web-ui/src/styles/mixins';
import Title from '@front/web-ui/src/components/base-text/variants/title';
import Text from '@front/web-ui/src/components/base-text/variants/text';

import { MembershipBackground } from './common';
import Advantages from './advantages';

const t = translate('modals.membership_paywall');

const StyledTitle = styled(Title.LG)`
  margin: 20px 0;

  ${minWidth.md`
    margin: 0 0 20px;
  `}
`;

const Subtitle = styled(Text)`
  margin-bottom: 20px;
`;

const WellnessCleaningSpotHeader = () => {
  const currentCountry = getCurrentCountry();

  return (
    <MembershipBackground>
      <StyledTitle>{t('.title.wellness_cleaning_spot')}</StyledTitle>
      <Text>
        {t('.subtitle.wellness_cleaning_spot.first_text', {
          pricePerMonth: formatPricePerMonth(MEMBERSHIP_CONFIG_BY_COUNTRY[currentCountry].monthlyPrice),
        })}
      </Text>
      <Subtitle>{t('.subtitle.wellness_cleaning_spot.second_text')}</Subtitle>
      <Advantages />
    </MembershipBackground>
  );
};

export default WellnessCleaningSpotHeader;
